import type { BusinessTerm } from '@wix/ambassador-funnel-taxonomy-v2-business-term/types'
import { retry, tryCatch } from '@wix/funnel-utils'
import { CancelTokenSource } from '@wix/http-client'

import { ambassadorHttpClient } from '../../../../api/httpClient'
import type { StateCategory } from '../../../reusable/Category/state/types'
import { MAX_QUERY_LENGTH } from './constants'

// This is without debounce, as this happens on click on chips
export async function extractCategory(
  query: string,
  _language: string, // currently not used, as extracted from aspects
  cancelToken: CancelTokenSource['token'],
  cb: (
    error: Error | undefined,
    businessTerm: StateCategory['businessTerm'],
    businessSegmentId: StateCategory['businessSegmentId'],
  ) => void,
) {
  const promise = retry(
    async ({ abort }) => {
      if (query.length > MAX_QUERY_LENGTH) {
        abort(new Error(`query length should be less than ${MAX_QUERY_LENGTH}`))
      }
      const res = await ambassadorHttpClient.post(
        '/_api/wildcat/extract/business-term',
        { about: query },
        { cancelToken },
      )
      if (!res.data) {
        throw new Error('no response from extract request')
      }
      const { businessTerm, mapping } = res.data as {
        businessTerm: BusinessTerm
        mapping?: { industryId?: string; structureId?: string }
      }
      if (!businessTerm) {
        abort(new Error('no term returned for given query'))
      }
      return { businessTerm, mapping }
    },
    { retries: 3, delayMs: 1000 },
  )
  const [error, data] = await tryCatch(() => promise)
  if (error) {
    console.error(error)
    cb(error, undefined, undefined)
    return
  }
  const { businessTerm, mapping } = data
  cb(
    undefined,
    {
      id: businessTerm.id,
      displayName: businessTerm.name,
      industryId: mapping?.industryId,
      structureId: mapping?.structureId,
      postRegVertical: businessTerm.postRegVertical,
      segmentationIndustryId: businessTerm.segmentationIndustryId,
      businessType: businessTerm.businessType,
      businessTermId: businessTerm.id,
      mainSegmentationIndustryId: businessTerm.mainSegmentationIndustryId ?? undefined,
    },
    businessTerm.businessSegmentId || undefined,
  )
}
